var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators/map';
import { merge } from 'rxjs/observable/merge';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
var DataTableSource = /** @class */ (function (_super) {
    __extends(DataTableSource, _super);
    function DataTableSource(init_data, init_paginator, init_sorter, init_sorterFn, filterColumns) {
        var _this = _super.call(this) || this;
        _this._filter = new BehaviorSubject('');
        _this._subrelease = new Subject();
        _this.FilteredDataUpdate = new EventEmitter();
        _this._database = new DataTableDatabase(init_data || []);
        _this._filteredData = _this._database.data;
        _this._paginator = init_paginator;
        _this._sorter = init_sorter;
        _this._sorterFn = init_sorterFn;
        _this.filterColumns = filterColumns;
        // Set up a subscription on filter changes (if any)
        _this._filter.pipe(takeUntil(_this._subrelease)).subscribe(function () {
            if (_this._paginator) {
                _this._paginator.pageIndex = 0;
            }
        });
        return _this;
    }
    Object.defineProperty(DataTableSource.prototype, "data", {
        get: function () {
            return this._database.data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableSource.prototype, "dataChange", {
        get: function () {
            return this._database.dataChange;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableSource.prototype, "filter", {
        get: function () {
            return this._filter.value;
        },
        set: function (value) {
            this._filter.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableSource.prototype, "filtereddata", {
        get: function () {
            return this._filteredData;
        },
        enumerable: true,
        configurable: true
    });
    DataTableSource.prototype.connect = function () {
        var _this = this;
        var triggers;
        triggers = [this._database.dataChange, this._filter];
        if (this._paginator != null) {
            triggers.push(this._paginator.page);
        }
        if (this._sorter != null) {
            triggers.push(this._sorter.sortChange);
        }
        return merge.apply(void 0, triggers).pipe(map(function () {
            var data = _this._database.data.slice();
            // Do we need to filter this data before sorting?
            if (_this.filterColumns) {
                var filterText_1 = _this.filter.toLowerCase();
                data = data.filter(function (item) {
                    var haveMatch = false;
                    _this.filterColumns.every(function (fitem) {
                        var value = item[fitem];
                        if (value && (!filterText_1 || value.toLowerCase().indexOf(filterText_1) >= 0)) {
                            haveMatch = true;
                            return false; // Stop looping
                        }
                        return true;
                    });
                    return haveMatch; // This is for the filter()
                });
            }
            _this._filteredData = data.slice();
            _this.FilteredDataUpdate.emit(_this._filteredData);
            // Do we need to sort this data before paginating?
            if (_this._sorter && _this._sorterFn && _this._sorter.active && _this._sorter.direction) {
                data = data.sort(_this._sorterFn);
            }
            var sorteddata = data.slice();
            if (_this._paginator) {
                var startIndex = _this._paginator == null ? 0 : _this._paginator.pageIndex * _this._paginator.pageSize;
                return sorteddata.splice(startIndex, _this._paginator.pageSize);
            }
            else {
                return sorteddata;
            }
        }));
    };
    DataTableSource.prototype.disconnect = function () { };
    // #region Attach Sorter Method
    DataTableSource.prototype.AttachSorter = function (_sorter) {
        this._sorter = _sorter;
    };
    // #endregion
    // #region Update Method
    DataTableSource.prototype.Update = function (_data) {
        this._database.dataChange.next(_data);
    };
    return DataTableSource;
}(DataSource));
export { DataTableSource };
var DataTableDatabase = /** @class */ (function () {
    function DataTableDatabase(_initdata) {
        this.dataChange = new BehaviorSubject([]);
        if (_initdata) {
            var _copied = _initdata.slice();
            this.dataChange.next(_copied);
        }
    }
    Object.defineProperty(DataTableDatabase.prototype, "data", {
        get: function () {
            return (this.dataChange.value || []);
        },
        enumerable: true,
        configurable: true
    });
    return DataTableDatabase;
}());
export { DataTableDatabase };



// WEBPACK FOOTER //
// ./src/classes/DataTableSource/datatablesource.ts.pre-build-optimizer.js